import React from 'react';

const WaterfallIcon = (props) => {
  return (
    <img
      alt="Wodospad"
      src="/static/images/icons/tourist_attractions/waterfall.svg"
      {...props}
    />
  );
};

export default WaterfallIcon;
